import React from "react";

function Bio() {
  return (
    <div className="text-left text-lg py-4">
      <img
        src="/assets/images/biopic.jpg"
        alt="Self Pic"
        className="h-[250px] w-auto mr-6 mb-4 float-left"
      />
      <div className="p-4">
        <p className="mt-2">
          Welcome! You've stumbled upon my little corner of the digital world.
          Here, I've gathered some of my past experiences in music. After
          digging through old hard drives, I found a collection of audio files,
          pictures, and videos that showcase my journey through music—the
          moments that aren't too embarrassing to share with the world.
        </p>
        <h3 className="text-2xl font-semibold my-4">A Little Background</h3>
        <p className="mt-2">
          It all started on July 2, 1995, at a friend’s house. An older friend
          of his showed up with his guitar and played "Fade to Black" by
          Metallica. It was the first time I truly saw someone play an
          instrument live, and it hit me: there were real, talented people
          behind the music I listened to. In that moment, I was captivated. I
          asked if he'd teach me to play guitar if I bought one the next day. He
          said yes, though I'm sure he didn’t think I was serious. The next day,
          I took all the money I'd saved from my summer job and bought my first
          guitar and a small amp.
        </p>
        <p className="mt-2">
          I went back to my friend’s house, eager to start learning. The guy was
          a bit surprised to see me with a guitar in hand, but he took a moment
          to show me how to read tablature. He even wrote a simple riff for me:
          on the low E string: <br />
          <code className="bg-gray-700 p-1 rounded">
            -0-0-2-0-3-0-5-4-
          </code>. <br />
        </p>
        <p className="mt-2">
          I played that riff an uncountable amount of times!
        </p>
        <p className="mt-2">
          He also taught me the intro to Metallica's "One." I practiced that
          diligently for a week, but when I met him again, he told me he didn’t
          have time to teach me further and suggested I buy guitar tab books.
          Back then, the internet wasn’t like it is today, and finding tabs was
          a challenge. I spent a lot of money on tab books and Guitar World
          magazine, constantly seeking new material to learn.
        </p>
        <p className="mt-2">
          By 1997, during my senior year of high school, I formed a makeshift
          band to try and play at the talent show—we didn’t make it in. They
          were only allowing one band in that year. Unfortunetly, there was a
          much better band. A little unfair though, considering the lead singer
          & guitar player was their father. Who obviously was not a member of
          our school. Instead of being discouraged, I focused on honing my
          skills. In 1999, I tried out for a band, but they were strictly a Sex
          Pistols cover band, which wasn't what I was looking for. I wanted to
          create original music.
        </p>
        <p className="mt-2">
          In 2000, I finally got my chance. I was invited to try out for another
          band, and I instantly clicked with the drummer and singer. They didn't
          have a bass player yet, but I was told the singer's brother could play
          bass. The singer pulled in his brother for that first practice and we
          formed a band and played together for the next three years. When my
          son was born, balancing a full-time graveyard shift job and band
          practice became too much, and I wasn't able to give the band the time
          they wanted. We went different directions.
        </p>
        <p className="mt-2">
          Fast forward to 2009: my old drummer, and some of the members that
          took my spot from the original band, reached out to start a new
          project, which led to the formation of "Picture Perfect." We converted
          a room in my parent's garage into a band room, and began writing
          enough material to put together an album. By 2010, we recorded a
          nine-song album at local studio, here in Oklahoma. Though the sessions
          were rushed, the experience was unforgettable. We ended up recording
          all 9 songs in two 4 hour sessions.
        </p>
        <p className="mt-2">
          Over time, we went through lineup changes and eventually rebranded as
          "Zeroed Out." We wrote new material, brought in different
          vocalists—including a female lead for the first time—and played many
          shows. We booked some studio time to record a couple of songs, but
          most of the songs you will hear on this site, from "Zeroed Out", I
          recorded and mixed from our band room and in my bedroom. It's
          unfortunate that we didn't record all our material. Our last show was
          in March 2015, opening for "Saving Abel." I didn't realize at that
          point, that would be the last time I'd play out live. At least at the
          time of writing this (2024). I got involved in a couple of other
          projects since 2015, but they didn't pan out. Although, I do think we
          wrote a few cool songs that I wish I had recorded.
        </p>
        <p className="mt-2">
          As the years have gone by, my priorities have shifted. While I no
          longer perform live, I still create music—mostly instrumentals and
          beats. I may eventually share some of that here, but for now, I hope
          you enjoy this glimpse into my musical journey. If you have any
          questions or just want to connect, feel free to email me at
          <a
            href="mailto:tony@caseboldt.com"
            className="text-blue-400 hover:underline ml-1"
          >
            tony@caseboldt.com
          </a>
          .
        </p>
        <p>- Tony Caseboldt</p>
      </div>
    </div>
  );
}

export default Bio;
